import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} BankStatementsConstants
 * @memberof BankStatements
 */
export const BankStatementsConstants = keyMirror({
  SET_IS_SAVING: undefined,
  SET_DATA_VERSION: undefined,
  GET_STATEMENTS: undefined,
  GET_STATEMENT: undefined,
  PROCESS_STATEMENT: undefined,
  GET_CONFIDENCE_THRESHOLD: undefined,
  GET_PDF_FILE: undefined,
  DELETE_STATEMENT: undefined,
  RESTORE_STATEMENT: undefined,
  UPDATE_TRANSACTION: undefined,
  UPDATE_ACCOUNT: undefined,
  DELETE_TRANSACTION: undefined,
  ADD_TRANSACTION: undefined,
  UPDATE_STATEMENT: undefined,
  RECONCILE_STATEMENT_ACCOUNT: undefined,
});
